<template>
    <h3 class="modal-section-label">Existing shares</h3>
    <InfoRow
        v-for="req in shareRequests"
        :key="req.id"
        :name="req.recipient_name"
    >
        <span class="info-row-stat">{{ req.since }}</span>
        <div class="status-badge" :class="req.status">
            {{ req.status }}
        </div>
    </InfoRow>
    <div v-if="!shareRequests.length" class="empty-state">
        Not shared with anyone yet.
    </div>
    <template v-if="!!friendOptions.length">
        <h3 class="modal-section-label">Share with friends</h3>
        <div class="form-field">
            <MultiselectableDropdown
                v-model="selectedFriends"
                :options="friendOptions"
                :loaded="true"
                placeholder="Choose friends…"
            />
        </div>
        <div class="actions">
            <Bttn @click="onShare">Share</Bttn>
        </div>
    </template>
</template>

<script>
import MultiselectableDropdown from "js/components/common/MultiselectableDropdown";
import InfoRow from "js/components/list-items/InfoRow";

import { useUserStore } from "js/stores/userStore";
import { create, fetch } from "js/lib/server";

export default {
    name: "ShareFriends",
    components: { MultiselectableDropdown, InfoRow },
    props: {
        itemId: {
            type: Number,
            default: null,
        },
        itemType: {
            type: String,
            default: null,
            validator(value) {
                return [
                    "trip",
                    "bucket_list",
                    "trip_idea",
                    "schedule",
                ].includes(value);
            },
        },
    },
    data() {
        return {
            selectedFriends: [],
            shareRequests: [],
            friendOptions: [],
        };
    },
    mounted() {
        this.userStore = useUserStore();
        fetch(`/api/invitations/?sent&${this.itemType}_id=${this.itemId}`).then(
            (response) => {
                const existing = {};
                this.shareRequests = [];
                response.data.data.forEach((friendRequest) => {
                    existing[friendRequest.recipient_id] = true;
                    this.shareRequests.push(friendRequest);
                });
                this.userStore.getFriends().then((options) => {
                    this.friendOptions = options.filter((opt) => {
                        return !existing[opt.id];
                    });
                });
            }
        );
    },
    methods: {
        getData() {
            const data = {};
            data[this.itemType + "_id"] = this.itemId;
            return data;
        },
        onShare() {
            const shares = this.selectedFriends.map((friend) => {
                const data = this.getData();
                data.friend_id = friend.id;

                return create("/api/invitations/", data).then((response) => {
                    this.shareRequests.push(response.data.data);
                    this.friendOptions = this.friendOptions.filter((opt) => {
                        return opt.id !== friend.id;
                    });
                });
            });

            Promise.all(shares).then(() => {
                this.selectedFriends = [];
            });
        },
    },
};
</script>
